import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Home from "../views/Home.vue";
import About from "../views/About.vue";
import User from "../views/User.vue";
import Delivery from "../views/Delivery.vue";
import Forgot from "../views/Forgot.vue";
import Summary from "../views/Summary.vue";
import Faqs from "../views/Faqs.vue";
import Auth from "../views/Auth.vue";
import Error from "../views/Error.vue"; // Page Not Found: 404 Page

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/user",
    name: "User",
    component: User,
  },
  {
    path: "/delivery",
    name: "Delivery",
    component: Delivery,
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: Forgot,
  },
  {
    path: "/summary",
    name: "Summary",
    component: Summary,
  },
  {
    path: "/faqs",
    name: "Faqs",
    component: Faqs,
  },
  {
    path: "/auth",
    name: "Auth",
    component: Auth,
  },
  {
    path: "/*",
    name: "Error",
    component: Error,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

// Create some navigation guards
router.beforeEach((to, from, next) => {
  // See if user is authenticated
  const isLoggedIn = localStorage.getItem("akaditi-soko-delivery") !== null;

  // Set isValidated state variable in the authentication module to the authenticatication status
  store.state.authentication.isValidated = isLoggedIn;

  // Get authentication status from store
  const isAuthenticated = store.getters.getAuthenticationStatus;

  // console.log(isAuthenticated);

  // Get user id from localstorage
  const uid = localStorage.getItem("uid") || null;

  // Check if user details has already been fetched
  const num = Object.keys(store.getters.getCollection("user")).length;

  // Make fetch for user details and store the details if user is logged in but details are not available
  if (uid && num <= 0)
    store
      .dispatch("makeFetch", {
        method: "get",
        withId: true,
        stateVar: "user",
      })
      .catch((err) => {
        console.log(err);
      });

  const ungardedRoutes = ["Home", "Auth", "Forgot", "Error", "Faqs", "About"];

  // // Redirect user to auth page if he/she is not logged in while accessing a route
  if (!ungardedRoutes.includes(to.name) && !isAuthenticated)
    next({ name: "Auth" });
  // Take user to homepage when trying to auth in while already logged in
  else if (to.name == "Auth" && isAuthenticated) next({ path: "/delivery" });
  else next();

  // next();
});

export default router;
